<template>
  <div>
    <div
      ref="grid"
      class="grid-stack"
    >
      <GridContainerItem
        v-for="(widget, index) in dashboardItems"
        :key="'widget-' + index"
        :widget="widget"
        @init-gridstack-widget="initGridstackWidget"
        @remove-gridstack-widget="removeGridstackWidget"
        @update-gridstack-widget="updateGridstackWidget"
        @updated-widget-settings="updateWidgetSettings"
      />
    </div>

  </div>
</template>

<script>
import { mapActions } from "vuex";

// import { GridStack } from 'gridstack'
// import 'gridstack/dist/gridstack.min.css'
// // import 'gridstack/dist/gridstack-extra.css' // < 12 cols
// import 'gridstack/dist/h5/gridstack-dd-native'

// importing jq version to allow touch drag&drop
import GridStack from "gridstack/dist/gridstack-jq.js";
import 'gridstack/dist/gridstack.min.css'

import GridContainerItem from "@/components/dashboard/GridContainerItem"

export default {
  name: 'GridContainer',
  components: { GridContainerItem },
  props: {
    dashboardItems: {
      type: Array,
      required: true,
    }
  },
  data () {
    return {
      gridInstance: undefined,
      count: 0,
      info: "",
      timerId: undefined,
      gridOptions: { 
        column: 12, 
        float: false, 
        cellHeight: '50px', 
        minRow: 1,
        handle: '.header',
      }
    }
  },
  mounted () {
    this.gridInstance = GridStack.init(this.gridOptions)
    this.gridInstance.on('change', () => this.saveCurrentDashboard('change'))
    this.gridInstance.on('added', () => this.saveCurrentDashboard('added'))
    this.gridInstance.on('removed', () => this.saveCurrentDashboard('removed'))
  },
  beforeDestroy () {
    this.gridInstance.destroy();
  },
  methods: {
    ...mapActions({ 
      updateTempUserWidgets: 'dashboard/updateTempUserWidgets'
    }),
    initGridstackWidget (widget) {
      this.gridInstance?.makeWidget(widget)
    },
    updateWidgetSettings () {
      this.saveCurrentDashboard()
    },
    removeGridstackWidget (widget) {
      let widget_el = widget
      if (typeof widget_el === 'string') {
        const grid_items = this.gridInstance?.getGridItems()
        widget_el = grid_items.find(w => w.id === widget)
      }
      this.gridInstance?.removeWidget(widget_el)
    },
    updateGridstackWidget (payload) {
      const targetEl = document.getElementsByClassName(payload.class)
      this.gridInstance.update(targetEl[0], payload.params)
    },
    saveCurrentDashboard (via) {
      const current_config = this.getDashboardCurrentConfig()
      if (via === 'removed' || via === 'added') {
        // update store data to rehydrate widget selector dropdown
        this.updateTempUserWidgets(current_config)
      }
      this.$emit('save-config', current_config)
    },
    getDashboardCurrentConfig () {
      const currentGrid = this.gridInstance.save(false, false)
      currentGrid.forEach( gridWidget => {
        const widgetOptions = this.$store.getters['dashboard/getWidget'](gridWidget.id)
        gridWidget.type = widgetOptions.type
        gridWidget.config = widgetOptions.config
        gridWidget.noRemove = widgetOptions.noRemove
      })
      return currentGrid
    }
  }
}
</script>

<style lang="scss">

.grid-stack {
  .grid-stack-placeholder {
    > .placeholder-content {
      border: 2px dotted $colorBrand;
      border-radius: $gridBorderRadius;
    }
  }
}

// .grid-stack > .grid-stack-item {
//   $gridstack-columns: 12;
//   min-width: calc(100% / $gridstack-columns);
//   @for $i from 0 through $gridstack-columns {
//     &[gs-w='#{$i}'] { width: calc(calc(100% / $gridstack-columns) * $i); }
//     &[gs-x='#{$i}'] { left: calc(calc(100% / $gridstack-columns) * $i); }
//     &[gs-min-w='#{$i}'] { min-width: calc(calc(100% / $gridstack-columns) * $i); }
//     &[gs-max-w='#{$i}'] { max-width: calc(calc(100% / $gridstack-columns) * $i); }
//   }
// }

</style>
